import React, { useEffect, useState } from "react";
import { Portal } from "react-portal";
import { useStores } from "_common/hooks";
import i18next from "i18next";

function ModalAbout({ open, onClose }) {
  const {
    authStore: { general },
  } = useStores();

  return (
    <Portal>
      <div
        className="modal modal-desktop"
        style={{ display: open ? "block" : "none" }}
      >
        <div className="mask" onClick={() => onClose()} />
        <div className="modal-content ">
          <div className="modal-header">
            <h2>{i18next.t("About")}</h2>
            <div className="btn-close" onClick={() => onClose()}>
              X
            </div>
          </div>
          <div className="classic-bet-now">
            <div className="content">
              <div className="rules__content">
                <h5>Chào mừng đến với HNX Trader</h5>
                <p>
                  Sàn giao dịch tiền kỹ thuật số Nasdaqtex được đăng ký tại San
                  Francisco, California vào năm 2011. Đây là nền tảng dịch vụ
                  tài chính tài sản kỹ thuật số toàn cầu. Đội ngũ sáng lập của
                  nó bao gồm các chuyên gia fintech cao cấp đến từ New York và
                  Singapore. Các nhà phát triển cốt lõi đều có nền tảng giao
                  dịch chứng khoán truyền thống hàng đầu và đã phát triển hệ
                  thống dịch vụ khách hàng và trao đổi hoàn chỉnh một cách độc
                  lập. Áp dụng hệ thống Spot 3.0 hàng đầu thế giới: ổn định hơn,
                  an toàn hơn và minh bạch hơn. Nasdaqtex tuân thủ nguyên tắc
                  người dùng là trên hết và liên tục lặp lại kiến trúc kỹ thuật
                  cơ bản để cải thiện trải nghiệm người dùng. Tập trung vào
                  chiến lược phát triển giao ngay + hợp đồng + quản lý tài
                  chính, nó cung cấp cho người dùng toàn cầu các dịch vụ tài
                  chính tài sản kỹ thuật số tập trung vào giao ngay, hợp đồng,
                  đòn bẩy, tùy chọn nhị phân, đầu tư và quản lý tài chính.
                  Nasdaqtex là nền tảng dịch vụ tài chính tài sản kỹ thuật số
                  quốc tế. Người dùng của nó đến từ 177 quốc gia trên thế giới
                  và có chi nhánh tại 13 thành phố bao gồm New York, London,
                  Singapore, Thành phố Hồ Chí Minh, Seoul và Tokyo. Tài nguyên
                  truyền thông bao phủ hơn 4.000 trang web trên khắp thế giới và
                  Bitcoin Cash là trang web phát triển nhanh nhất thế giới vào
                  năm 2020. Kể từ tháng 1 năm nay, đã có 1,65 triệu người dùng
                  đăng ký mới, nâng tổng số người dùng đã đăng ký lên 18 triệu.
                  Nasdaqtex cam kết xây dựng nền tảng dịch vụ tài chính số với
                  trải nghiệm khách hàng tốt, nhiều người dùng đăng ký mới và
                  kiến trúc kỹ thuật ổn định, an toàn!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
}

export default ModalAbout;
